'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _signupOrLoginButton = require('./common/signup-or-login-button');

var _signupOrLoginButton2 = _interopRequireDefault(_signupOrLoginButton);

var _HS_logo_white = require('../assets/HS_logo_white.svg');

var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);

var _eventbrite_logo = require('../assets/eventbrite_logo.png');

var _eventbrite_logo2 = _interopRequireDefault(_eventbrite_logo);

var _eventbrite_integration = require('../assets/eventbrite_integration.svg');

var _eventbrite_integration2 = _interopRequireDefault(_eventbrite_integration);

var _send_icon = require('../assets/send_icon.svg');

var _send_icon2 = _interopRequireDefault(_send_icon);

var _customize_logo = require('../assets/customize_logo.svg');

var _customize_logo2 = _interopRequireDefault(_customize_logo);

var _dashboard_icon = require('../assets/dashboard_icon.svg');

var _dashboard_icon2 = _interopRequireDefault(_dashboard_icon);

var _overlay_left = require('../assets/overlay_left.svg');

var _overlay_left2 = _interopRequireDefault(_overlay_left);

var _overlay_right = require('../assets/overlay_right.svg');

var _overlay_right2 = _interopRequireDefault(_overlay_right);

var _social_twitter2x = require('../assets/social_twitter@2x.png');

var _social_twitter2x2 = _interopRequireDefault(_social_twitter2x);

var _social_facebook2x = require('../assets/social_facebook@2x.png');

var _social_facebook2x2 = _interopRequireDefault(_social_facebook2x);

var _social_linkedin2x = require('../assets/social_linkedin@2x.png');

var _social_linkedin2x2 = _interopRequireDefault(_social_linkedin2x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx(PricingPlansCTA, {
    position: 'top'
});

var _ref2 = _jsx(Benefits, {});

var _ref3 = _jsx(HowItWorks, {});

var _ref4 = _jsx(Social, {});

var _ref5 = _jsx(FAQ, {});

var _ref6 = _jsx(PricingPlansCTA, {
    position: 'bottom'
});

function EventbriteLandingPage(p) {
    return _jsx('div', {
        className: 'seo-cloud-integrations'
    }, void 0, _react2['default'].createElement(IllustrationArea, p), _jsx('div', {
        className: 'seo-cloud-integrations__main',
        style: { backgroundColor: 'white' }
    }, void 0, _ref, _ref2, _ref3, _ref4, _ref5, _ref6));
}

var _ref7 = _jsx('img', {
    src: _HS_logo_white2['default'],
    alt: 'HelloSign Logo',
    className: 'hs-logo'
});

var _ref8 = _jsx('img', {
    src: _eventbrite_logo2['default'],
    alt: 'Eventbrite Logo',
    className: 'dropbox-logo',
    width: '130'
});

function IllustrationArea(p) {
    // This overlay is slightly off from the other integrations. This transform
    // compensate for that.
    var imageStyle = { transform: 'translateY(1px)' };
    return _jsx('div', {
        className: 'top row drobox-blue'
    }, void 0, _jsx('div', {
        className: 'top-content-container large-5 large-push-6 columns'
    }, void 0, _jsx('div', {
        className: 'hellosign-dropbox'
    }, void 0, _ref7, _jsx('span', {
        className: 'plus'
    }, void 0, '+'), _ref8), _jsx('div', {
        className: 'title'
    }, void 0, _jsx('h1', {}, void 0, 'Seamlessly Collect Event Waivers and Forms')), _jsx('div', {
        className: 'subtitle'
    }, void 0, _jsx('h2', {
        style: { fontWeight: 400, fontSize: 16, maxWidth: 600 }
    }, void 0, 'The HelloSign Waivers & Forms extension for Eventbrite allows you to send any event-related documents to your attendees for legally-binding signature. We’ve made it easy to send, track, collect, and get real-time status updates on your photo releases, sponsor and exhibitor agreements, permission slips, waivers, and more for your Eventbrite event.')), _react2['default'].createElement(SignupButton, p)), _jsx('div', {
        className: 'clouds-container large-5 large-pull-4 columns'
    }, void 0, _jsx('img', {
        src: _eventbrite_integration2['default'],
        alt: 'cloud left',
        style: { marginTop: 23 }
    })), _jsx('img', {
        src: _overlay_left2['default'],
        style: imageStyle,
        alt: 'cloud left',
        className: 'cloud-left'
    }), _jsx('img', {
        src: _overlay_right2['default'],
        style: imageStyle,
        alt: 'cloud right',
        className: 'cloud-right'
    }));
}

function SignupButton(p) {
    var buttonClass = 'm-button bg-cerulean hc-white c-white progress-button state-loading m-login-or-signup--sign-up-button';
    var linkURL = 'https://www.eventbrite.com/spectrum/hellosign/';

    return _jsx('div', {
        className: 'signup-button'
    }, void 0, _jsx('a', {
        href: linkURL,
        className: buttonClass
    }, void 0, 'ENABLE HELLOSIGN WAIVERS & FORMS'));
}

var _ref9 = _jsx('img', {
    src: _send_icon2['default'],
    alt: 'folder icon'
});

var _ref10 = _jsx('img', {
    src: _customize_logo2['default'],
    alt: 'signature icon'
});

var _ref11 = _jsx('img', {
    src: _dashboard_icon2['default'],
    alt: 'cloud icon'
});

function Benefits(p) {
    var titleStyle = {
        display: 'inline-block',
        maxWidth: 250
    };
    return _jsx('div', {
        className: 'seo-cloud-integrations__benefits'
    }, void 0, _jsx('h2', {}, void 0, 'Benefits'), _jsx('div', {
        className: 'row'
    }, void 0, _jsx('section', {
        className: 'access-dropbox-from-hs large-4 columns'
    }, void 0, _jsx('div', {
        className: 'benefits-image-container'
    }, void 0, _ref9), _jsx('h3', {}, void 0, _jsx('span', {
        style: titleStyle
    }, void 0, 'Send important forms automatically')), _jsx('p', {}, void 0, 'Send your event documents to attendees that have already registered and to any new attendees automatically as they join. We can pre-fill fields they’ve already entered.')), _jsx('section', {
        className: 'sign-any-from-dropbox large-4 columns'
    }, void 0, _jsx('div', {
        className: 'benefits-image-container'
    }, void 0, _ref10), _jsx('h3', {}, void 0, _jsx('span', {
        style: titleStyle
    }, void 0, 'Customize your documents')), _jsx('p', {}, void 0, 'Upload unique documents for different ticket types, automatically pull attendee data into your documents, and brand your documents with your logo, company name, and more!')), _jsx('section', {
        className: 'save-signed-copies large-4 columns end'
    }, void 0, _jsx('div', {
        className: 'benefits-image-container'
    }, void 0, _ref11), _jsx('h3', {}, void 0, _jsx('span', {
        style: titleStyle
    }, void 0, 'Get real-time status reports')), _jsx('p', {}, void 0, 'Check the status of any document out for signature for any attendee from your Eventbrite dashboard and download a report to simplify day-of-event check-ins.'))));
}

function HowItWorks(p) {
    var linkURL = "http://blog.hellosign.com/hellosign-and-eventbrite-integration/";
    var link = _jsx('a', {
        href: linkURL
    }, void 0, 'Read our blog post');
    var videoProps = {
        src: 'https://www.youtube.com/embed/mQkUMjH_DxE',
        frameBorder: 0,
        style: {
            width: '100%',
            maxWidth: 800,
            height: 430
        }
    };
    var paragraphStyle = {
        marginLeft: 20
    };

    return _jsx('div', {
        className: 'seo-cloud-integrations__how-it-works'
    }, void 0, _jsx('h2', {}, void 0, 'How it Works'), _jsx('div', {
        className: 'row'
    }, void 0, _jsx('div', {
        className: 'screenshot-explanation large-3 large-push-9 columns'
    }, void 0, _jsx('p', {
        style: paragraphStyle
    }, void 0, 'To get started, find the HelloSign Waivers & Forms extension in Eventbrite Spectrum.'), _jsx('p', {
        style: paragraphStyle
    }, void 0, 'Once you add the extension to your event, you can upload documents, assign them to ticket types, automatically send your documents to registered attendees, and see which documents are still out for signature.'), _jsx('p', {
        style: paragraphStyle
    }, void 0, 'All of the docs you send through the extension will show up in the documents view on HelloSign.com.'), _jsx('p', {
        style: paragraphStyle
    }, void 0, 'Want to learn more about the integration? ', link, '.')), _jsx('div', {
        className: 'dropbox-screenshot large-9 large-pull-3 columns'
    }, void 0, _react2['default'].createElement('iframe', videoProps))));
}

var _ref12 = _jsx('img', {
    src: _social_twitter2x2['default'],
    alt: 'twitter share'
});

var _ref13 = _jsx('img', {
    src: _social_facebook2x2['default'],
    alt: 'facebook share',
    className: 'facebook-share'
});

var _ref14 = _jsx('img', {
    src: _social_linkedin2x2['default'],
    alt: 'linkedin share'
});

function Social(p) {
    var twitterLink = 'https://twitter.com/intent/tweet?text=It%27s%20easy%20to%20get%20attendee%20waivers%20%26%20forms%20signed%20with%20%40HelloSign%20%2B%20%40Eventbrite&url=https%3A%2F%2Fwww.hellosign.com%2Feventbrite%3Futm_source%3Dtwitter%26utm_medium%3Ds2s';
    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/eventbrite?utm_source=facebook%26utm_medium=s2s';
    var linkedinLink = 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.hellosign.com/eventbrite?utm_source=linkedin%26utm_medium=s2s&title=Check%20out%20the%20HelloSign%20Extension%20for%20Eventbrite&summary=It%27s%20easy%20to%20get%20attendee%20waivers%20%26%20forms%20signed%20with%20HelloSign%20%2B%20Eventbrite.%20https%3A//www.hellosign.com/eventbrite';

    return _jsx('div', {
        className: 'seo-cloud-integrations__social',
        style: { marginTop: 50 }
    }, void 0, _jsx('h2', {
        style: { marginBottom: 30 }
    }, void 0, 'Share with your networks!'), _jsx('a', {
        href: twitterLink
    }, void 0, _ref12), _jsx('a', {
        href: facebookLink
    }, void 0, _ref13), _jsx('a', {
        href: linkedinLink
    }, void 0, _ref14));
}

function FAQ(p) {
    var buttonClass = "m-button bg-cerulean  hbg-castle-rock c-white progress-button state-loading m-login-or-signup--sign-up-button";
    var link = "https://faq.hellosign.com/hc/en-us/sections/204169818-Eventbrite";

    return _jsx('div', {
        className: 'seo-cloud-integrations__faq'
    }, void 0, _jsx('p', {}, void 0, 'Questions about this integration? We have answers.'), _jsx('button', {
        className: buttonClass
    }, void 0, _jsx('span', {
        className: 'l-nowrap'
    }, void 0, _jsx('a', {
        href: link,
        className: 'faq-link'
    }, void 0, 'VIEW OUR FAQ'))));
}

function PricingPlansCTA(p) {
    var position = p.position;
    var className = 'seo-cloud-integrations__main__free_accounts__' + position;
    var linkURL = 'eventbrite/pricing';
    var link = _jsx('a', {
        href: linkURL,
        style: { fontWeight: 500 }
    }, void 0, 'See Our Plans');
    var border = '2px solid #D7D7D7';
    var style = {};
    if (position === 'top') {
        style['borderBottom'] = border;
        style['backgroundColor'] = '#f7f8f9';
    } else {
        style['borderTop'] = border;
    }

    return _jsx('div', {
        className: className,
        style: style
    }, void 0, _jsx('p', {
        style: { fontWeight: 600, lineSpacing: 0 }
    }, void 0, 'The HelloSign Waivers and Forms extension for Eventbrite plans start at $29 a month. ', link, '.'));
}

module.exports = EventbriteLandingPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/eventbrite-landing-page.jsx
 ** module id = 857
 ** module chunks = 0
 **/